import { autorun, when } from 'mobx';
import { once } from '../../js/utils';
import { AnalyticsStore } from '../AnalyticsStore';
import { MraidStore } from '../MraidStore';
import { TimerStore } from '../TimerStore';

const DELAY = 1000;
const THRESHOLD = 100;

interface Mrc100TrackHandlerProps {
  mraidStore: MraidStore;
  analyticsStore: AnalyticsStore;
  formatConfig: any;
}

export class Mrc100TrackHandler {
  mraidStore: MraidStore;
  timerStore: TimerStore;
  analyticsStore: AnalyticsStore;
  formatConfig: any;

  isFullyViewable: boolean = false;

  constructor({
    mraidStore,
    analyticsStore,
    formatConfig
  }: Mrc100TrackHandlerProps) {
    this.mraidStore = mraidStore;
    this.analyticsStore = analyticsStore;
    this.formatConfig = formatConfig;
    this.timerStore = new TimerStore({ delay: DELAY });
    this.handle = once(this.handle);

    if (!this.hasTrackers()) {
      return;
    }

    autorun(() => {
      if (this.timerStore.isFinished) return;

      const isFullyViewable = this.mraidStore.exposure >= THRESHOLD;
      if (isFullyViewable === this.isFullyViewable) return;

      this.isFullyViewable = isFullyViewable;
      if (isFullyViewable) {
        this.timerStore.resume();
      } else {
        this.timerStore.pause();
      }
    });

    when(
      () => this.timerStore.isFinished,
      () => this.handle()
    );
  }

  handle() {
    const imgTrackers = this.formatConfig?.mrc100ImgTrackers || [];
    const jsTrackers = this.formatConfig?.mrc100JsTrackers || [];
    imgTrackers.forEach((url: string) => this.analyticsStore.sendTrack(url));
    jsTrackers.forEach((url: string) => this.analyticsStore.sendJsTrack(url));
  }

  private hasTrackers(): boolean {
    return (
      this.formatConfig?.mrc100ImgTrackers?.length > 0 ||
      this.formatConfig?.mrc100JsTrackers?.length > 0
    );
  }
}
